// extracted by mini-css-extract-plugin
export default {"box":"aboutUs_box__im2lH","text":"aboutUs_text__3eZzs","div":"aboutUs_div__8D+X3"};